import { Centered, FullScreenContainer } from '@gorila-shared-ui/components';
import { useEffect, useState } from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import {
  CLIENTS_PAGE,
  COMPANIES_PAGE,
  FORMS_PAGE,
  JOBS_CALENDAR_PAGE,
  JOBS_PAGE,
  JOBS_SKILLS_PAGE,
  JOBS_TYPES_PAGE,
  JOB_TYPE_PAGE,
  LOGIN_PAGE,
  NOT_FOUND_PAGE,
  SERVER_ERROR_PAGE,
  USERS_PAGE,
} from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { JobsCalendarPage } from '../jobs/calendar/JobsCalendarPage';
import { FSMLayout } from '../layout/FSMLayout';
import { HelmetLayout } from '../layout/HelmetLayout';
import { CompanyListPage } from '../pages/CompanyListPage';
import { FormListPage } from '../pages/FormListPage';
import { JobSkillsListPage } from '../pages/JobSkillsListPage';
import { JobTypeDetailPage } from '../pages/JobTypeDetailPage';
import { JobTypesListPage } from '../pages/JobTypesListPage';
import { JobsPage } from '../pages/JobsPage';
import { LoginPage } from '../pages/LoginPage';
import { ServerErrorPage } from '../pages/ServerErrorPage';
import { TenantsListPage } from '../pages/TenantsListPage';
import { UsersListPage } from '../pages/UsersListPage';
import { ErrorElementBoundary } from '../shared/ErrorBoundary';

const router = createBrowserRouter([
  {
    id: 'root',
    element: <HelmetLayout />,
    children: [
      {
        id: LOGIN_PAGE.id,
        path: LOGIN_PAGE.route,
        element: <LoginPage />,
        errorElement: <ErrorElementBoundary />,
      },
      {
        id: 'home',
        element: <FSMLayout />,
        errorElement: <ErrorElementBoundary />,
        children: [
          {
            id: USERS_PAGE.id,
            path: USERS_PAGE.route,
            element: <UsersListPage />,
          },
          {
            id: JOBS_PAGE.id,
            path: JOBS_PAGE.route,
            element: <JobsPage />,
          },
          {
            id: JOBS_CALENDAR_PAGE.id,
            path: JOBS_CALENDAR_PAGE.route,
            element: <JobsCalendarPage />,
          },
          {
            id: JOBS_SKILLS_PAGE.id,
            path: JOBS_SKILLS_PAGE.route,
            element: <JobSkillsListPage />,
          },
          {
            id: JOBS_TYPES_PAGE.id,
            path: JOBS_TYPES_PAGE.route,
            element: <JobTypesListPage />,
          },
          {
            id: JOB_TYPE_PAGE.id,
            path: JOB_TYPE_PAGE.route,
            element: <JobTypeDetailPage />,
          },
          {
            id: CLIENTS_PAGE.id,
            path: CLIENTS_PAGE.route,
            element: <TenantsListPage />,
          },
          {
            id: COMPANIES_PAGE.id,
            path: COMPANIES_PAGE.route,
            element: <CompanyListPage />,
          },
          {
            id: FORMS_PAGE.id,
            path: FORMS_PAGE.route,
            element: <FormListPage />,
          },
          {
            id: 'main',
            path: '/',
            element: (
              <Navigate
                to={USERS_PAGE.route}
                replace
              />
            ),
          },
        ],
      },
      {
        id: NOT_FOUND_PAGE.id,
        path: NOT_FOUND_PAGE.route,
        element: <Centered>404</Centered>,
      },
      {
        id: SERVER_ERROR_PAGE.id,
        path: SERVER_ERROR_PAGE.route,
        element: <ServerErrorPage />,
      },
    ],
  },
]);

export function AppRoutes() {
  const { classes, theme } = useStyles();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.fonts.ready.then(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  }, []);

  return (
    <FullScreenContainer>
      <RouterProvider router={router} />
      {loading && (
        <div
          className={`${classes.verticalFlex} ${classes.centeredFlex}`}
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: theme.colors.backgroundInversePrimary,
          }}
        >
          <img
            alt="Gorila MX"
            src="/img/login_logo.png"
            height={50}
            style={{
              animation: 'pulse 2s infinite',
            }}
          />
        </div>
      )}
    </FullScreenContainer>
  );
}
